import { SET_SELECTED_LOAN } from '../actions/types';

const initialState = {
  selectedLoan: {},
};

const reducer = function (state = initialState, action) {
  switch (action.type) {
    case SET_SELECTED_LOAN:
      return {
        ...state,
        selectedLoan: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
